import { integer, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { customTimestamp } from "./utils/types";

export const eligibilityLastStepEnumSchema = z.enum([
  "MARITAL_STATUS",
  "LIVE_CARE_CHILDREN",
  "PARENT_GUARDIAN_STUDENT",
  "SUPPORT_DISABLED_INDIVIDUAL",
  "SUPPORT_OTHER_RELATIVES",
  "HOUSEHOLD_INCOME",
  "SOMEONE_SUPPORTS_YOU",
  "FINISHED",
]);
export type EligibilityLastStepEnumType = z.infer<
  typeof eligibilityLastStepEnumSchema
>;
export const householdsTable = pgTable("households", {
  id: uuid("id").primaryKey().defaultRandom(),
  householdIncome: integer("household_income"),
  eligibilityLastStep: text(
    "eligibility_last_step",
  ).$type<EligibilityLastStepEnumType>(),
  createdAt: customTimestamp("created_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString()),
  updatedAt: customTimestamp("updated_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString())
    .$onUpdateFn(() => new Date().toISOString()),
});

export const householdInsertSchema = createInsertSchema(householdsTable, {
  householdIncome: z.number().optional(),
  eligibilityLastStep: eligibilityLastStepEnumSchema.optional(),
}).omit({
  createdAt: true,
  updatedAt: true,
});
export type HouseholdInsertType = z.infer<typeof householdInsertSchema>;

export const householdSchema = createSelectSchema(householdsTable, {
  eligibilityLastStep: eligibilityLastStepEnumSchema.nullish(),
});
export type HouseholdType = z.infer<typeof householdSchema>;

export const householdUpdateSchema = householdInsertSchema
  .omit({
    id: true,
  })
  .partial();
export type HouseholdUpdateType = z.infer<typeof householdUpdateSchema>;
